import React from "react";
import ComponentDescription from "components/customs/ComponentDescription";
import ComponentHeader from "components/cms/ComponentHeader";
import { MusicPlatformAudioDefinitions } from "./MusicPlatformAudioDefinitions";

export class MusicPlatformAudio extends MusicPlatformAudioDefinitions {
    render() {
        const { className, designing } = this.props;

        if (this.props.hideRuntime && !this.props.designing) return null;
        const text = this.props.schemaNode?.getProp("children");
        return (
            <React.Fragment>
                <div
                    data-schema-id={this.props.id}
                    className={[
                        "fa-draggable disable-inside",
                        designing && "designing",
                        className
                    ]
                        .filter((e) => !!e)
                        .join(" ")}
                >
                    {designing && (
                        <ComponentHeader
                            componentEntry={this.props.entry}
                            componentSchemaId={this.props.id as string}
                        />
                    )}
                    <ComponentDescription
                        text={text || "Müzik Platform"}
                        node={this.props.schemaNode}
                        entry={this.props.entry}
                    />
                </div>
            </React.Fragment>
        );
    }
}

